import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/build/repo/src/app/past-scholarship-winners/_components/ClientSidePastScholarshipWinners/ClientSidePastScholarshipWinnersWrapper.tsx");
